module.exports = __webpack_public_path__ + "img/ico-sro.aa1030c2.svg";